import styled from 'styled-components';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { Blurrable } from '../../shared/Blurrable';
import { mockUtteranceDataForPQL } from '../../../data/mockData/MockUtterances';
import { TranscriptUtterance } from '../TranscriptUtterance';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNoScrollBar = styled.div.withConfig({
  displayName: "BlurredTranscript__StyledNoScrollBar"
})(["overflow-y:auto;::-webkit-scrollbar{display:none;}scrollbar-width:none;-ms-overflow-style:none;"]);
export const BlurredTranscript = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SearchInput, {
      disabled: true
    }), /*#__PURE__*/_jsx(Blurrable, {
      isBlurred: true,
      children: /*#__PURE__*/_jsx(StyledNoScrollBar, {
        children: mockUtteranceDataForPQL.map((mockUtteranceData, index) => {
          return /*#__PURE__*/_jsx(TranscriptUtterance, {
            utteranceData: mockUtteranceData,
            utteranceId: '',
            onShareIconClick: () => {},
            onCommentIconClick: () => {}
          }, index);
        })
      })
    })]
  });
};